import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Grid,
  Modal,
  Input,
} from '../../../src/components/index';

class ModalRetornoIntegracaoGet extends Component {
  modalContent = () => (
    <React.Fragment>
      <div className="row">
        <Grid cols="3 3 3 3">
          <Input
            style={{ color: '#00314d' }}
            label="Protocolo Tarefa GET"
            value={this.props.estadoFormulario.conteudoModalIntegracaoGet.idTarefaGet}
            disabled
          />
        </Grid>
      </div>
      <div className="row">
        <Grid cols="3 3 3 3">
          <Input
            style={{ color: '#00314d' }}
            label="Sigla"
            value={this.props.estadoFormulario.conteudoModalIntegracaoGet.sigla}
            disabled
          />
        </Grid>
        <Grid cols="9 9 9 9">
          <Input
            style={{ color: '#00314d' }}
            label="Nome do Serviço"
            value={this.props.estadoFormulario.conteudoModalIntegracaoGet.nomeServico}
            disabled
          />
        </Grid>
      </div>
      <div className="row">
        <Grid cols="3 3 3 3">
          <Input
            style={{ color: '#00314d' }}
            label="Data da Criação"
            value={this.props.estadoFormulario.conteudoModalIntegracaoGet.dataCriacao}
            disabled
          />
        </Grid>
        <Grid cols="9 9 9 9">
          <Input
            style={{ color: '#00314d' }}
            label="Status"
            value={this.props.estadoFormulario.conteudoModalIntegracaoGet.statusTarefa}
            disabled
          />
        </Grid>
      </div>
    </React.Fragment>
  )
  modalFooter = () => (
    <React.Fragment>
      <div className="right">
        <Button
          title="Fechar"
          onClick={this.handleCloseIntegracaoGet}
          hint="Fechar"
        />
      </div>
    </React.Fragment>
  )

  handleCloseIntegracaoGet = () => {
    this.setState(this.props.handleModal('showDadosRetornoGetModal'));
  }
  render() {
    return (
      <Modal
        {...this.props}
        conteudofooter={this.modalFooter()}
        conteudomodal={this.modalContent()}
        onHide={this.handleCloseIntegracaoGet}
        size="lg"
        showModal={this.props.showModal}
        title="Status atual da Tarefa no GET"
      />
    );
  }
}

ModalRetornoIntegracaoGet.propTypes = {
  showModal: PropTypes.func,
  handleModal: PropTypes.func,
  estadoFormulario: PropTypes.objectOf(PropTypes.object).isRequired,
  auth: PropTypes.objectOf(PropTypes.object).isRequired,
}.isRequired;

export default ModalRetornoIntegracaoGet;



// WEBPACK FOOTER //
// ./src/pages/consultas/ModalRetornoIntegracaoGet.jsx